import { render, staticRenderFns } from "./ComponenteChat.vue?vue&type=template&id=311476fe&"
import script from "./ComponenteChat.vue?vue&type=script&lang=ts&"
export * from "./ComponenteChat.vue?vue&type=script&lang=ts&"
import style0 from "./ComponenteChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports